// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14B7n","colBig":"styles_colBig__OBM_5","colSmall":"styles_colSmall__4FgEA"};